import { useEffect } from 'react';

import { Login } from '@/components/login';
import { trackEvent } from '@/lib/mixpanel';

export default function LoginPage() {
  useEffect(() => {
    trackEvent('LOGIN_VIEWED');
  }, []);

  return <Login />;
}
